import { AutoStack } from 'components'
import { FieldArray } from 'formik'
import { FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { DefaultButton, IconButton, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type GlobalOptionsFormValues = { options: string[] } & {
  type: string
}

export const GlobalOptionsForm: React.FunctionComponent<{}> = () => {
  const { t } = useTranslation()

  return (
    <FormStack>
      <FieldArray name="options">
        {({ form, name, ...helpers }) => {
          const values: { type: string; options: string[] } = form.values
          return (
            <AutoStack tokens={{ childrenGap: 12 }}>
              <Label>{t(`enum.keywordType.${values.type}`)}</Label>

              {values.options.map((x: any, i: number) => (
                <FieldStack horizontal={true} key={i}>
                  <FieldStackItem
                    name={`options[${i}]`}
                    render={(fieldProps) => <FormikTextField {...fieldProps} />}
                  />

                  <IconButton
                    styles={{
                      root: { color: 'red', marginTop: 'auto' },
                    }}
                    iconProps={{ iconName: 'Delete' }}
                    onClick={() => helpers.remove(i)}
                  />
                </FieldStack>
              ))}
              <FieldStack horizontal={true}>
                <DefaultButton
                  text={'+'}
                  onClick={() => {
                    helpers.push('')
                  }}
                />
              </FieldStack>
            </AutoStack>
          )
        }}
      </FieldArray>
    </FormStack>
  )
}
